import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { useUserContext } from "../context/UserContext";
import UserAvatar from "../helpers/UserAvatar";
import { FaBuilding } from 'react-icons/fa';

const MEDIA_BASE = 'https://buzzinguniverse.com/backend';

const Navigation = ({ usrData, setTabb }) => {
    const { myPendingRequests, activeProfile, setActiveProfile, myAdminEntities } = useUserContext();
    const pendingCount = myPendingRequests?.length || 0;
    const [isOpen, setIsOpen] = useState(false);
    const [showSwitcher, setShowSwitcher] = useState(false);
    const [switchAnim, setSwitchAnim] = useState(null); // { name, photo, type }
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setShowSwitcher(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const navigate = useNavigate();

    const checkImageSource = (src) =>
        src !== `${MEDIA_BASE}/` ? src : null;

    const ChaNgeTab = (val) => {
        setTabb(val);
        setIsOpen(false);
        setShowSwitcher(false);
        navigate(`/member/${usrData.id}/profile`);
    };

    const Logout = (e) => {
        e.preventDefault();
        setActiveProfile(null);
        secureLocalStorage.removeItem('auth_data');
        window.location.href = "/";
    };

    const triggerSwitch = (profile) => {
        setSwitchAnim(profile);
        setTimeout(() => {
            setActiveProfile(profile);
        }, 600);
        setTimeout(() => {
            setSwitchAnim(null);
        }, 2000);
    };

    const getEntityDefaultPhoto = (entity) => {
        if (entity.profile_picture) return `${MEDIA_BASE}/${entity.profile_picture}`;
        return entity.type === 'company' ? null : '/images/mystery-group.png';
    };

    const handleSwitch = (entity) => {
        setShowSwitcher(false);
        setIsOpen(false);
        triggerSwitch({
            type: entity.type || 'group',
            id: entity.id,
            name: entity.name,
            photo: getEntityDefaultPhoto(entity),
        });
    };

    const handleSwitchToPersonal = () => {
        setShowSwitcher(false);
        setIsOpen(false);
        triggerSwitch({
            type: 'personal',
            id: usrData.id,
            name: `${usrData.fname} ${usrData.lname || ''}`.trim(),
            photo: usrData.photo || '/images/default.png',
        });
        // Actually clear after delay
        setTimeout(() => setActiveProfile(null), 600);
    };

    // What shows in the avatar area
    const displayName  = activeProfile ? activeProfile.name  : usrData.fname;
    const displayPhoto = activeProfile
        ? activeProfile.photo
        : (checkImageSource(usrData.photo) ? usrData.photo : '/images/default.png');

    return (
        <>
        {switchAnim && (
            <div className={`ps-overlay ${switchAnim ? 'ps-overlay-enter' : ''}`}>
                <div className="ps-card">
                    <div className="ps-avatar-ring">
                        {switchAnim.photo
                            ? <img src={switchAnim.photo} alt={switchAnim.name} className="ps-avatar-img" />
                            : <div className="nav-company-placeholder ps-avatar-img"><FaBuilding /></div>
                        }
                    </div>
                    <div className="ps-label">
                        {switchAnim.type === 'personal' ? 'Switching back to' : 'Switching to'}
                    </div>
                    <div className="ps-name">{switchAnim.name}</div>
                    {switchAnim.type !== 'personal' && (
                        <div className="ps-type-badge">{switchAnim.type === 'company' ? 'Company' : 'Group'}</div>
                    )}
                    <div className="ps-dots">
                        <span /><span /><span />
                    </div>
                </div>
            </div>
        )}
        <div className="navigation text-start" ref={dropdownRef}>
            <button className="nav-btn" onClick={() => { setIsOpen(!isOpen); setShowSwitcher(false); }} style={{ position: 'relative' }}>
                <UserAvatar src={displayPhoto} alt="User" className="user-img" isCompany={!!activeProfile && activeProfile.type !== 'personal'} />
                {/* <h3 className="user-name">{displayName}</h3> */}
                {pendingCount > 0 && (
                    <span style={{
                        position: 'absolute', top: '-6px', right: '-6px',
                        background: '#ff4444', color: '#fff', borderRadius: '50%',
                        fontSize: '11px', fontWeight: 'bold', minWidth: '18px',
                        height: '18px', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', lineHeight: 1, padding: '0 3px'
                    }}>{pendingCount}</span>
                )}
            </button>

            {isOpen && (
                <div className="navigate-dropdown">
                    {/* Switch Profile section */}
                    {myAdminEntities.length > 0 && (
                        <div className="nav-switch-section">
                            <div className="nav-switch-label">Switch Profile</div>

                            {/* Currently active indicator */}
                            <div
                                className={`nav-switch-item ${!activeProfile ? 'nav-switch-active' : ''}`}
                                onClick={handleSwitchToPersonal}
                            >
                                <UserAvatar
                                    src={checkImageSource(usrData.photo) ? usrData.photo : '/images/default.png'}
                                    alt="personal"
                                    className="nav-switch-avatar"
                                />
                                <span>{usrData.fname} {usrData.lname} <small>(Personal)</small></span>
                                {!activeProfile && <span className="nav-switch-tick">✓</span>}
                            </div>

                            {myAdminEntities.map((entity) => (
                                <div
                                    key={entity.id}
                                    className={`nav-switch-item ${activeProfile?.id === entity.id ? 'nav-switch-active' : ''}`}
                                    onClick={() => handleSwitch(entity)}
                                >
                                    {entity.profile_picture ? (
                                        <img
                                            src={`${MEDIA_BASE}/${entity.profile_picture}`}
                                            alt={entity.name}
                                            className="nav-switch-avatar"
                                        />
                                    ) : entity.type === 'company' ? (
                                        <div className="nav-switch-avatar nav-company-placeholder"><FaBuilding /></div>
                                    ) : (
                                        <img
                                            src="/images/mystery-group.png"
                                            alt={entity.name}
                                            className="nav-switch-avatar"
                                        />
                                    )}
                                    <span>{entity.name} <small>({entity.type === 'company' ? 'Company' : 'Group'})</small></span>
                                    {activeProfile?.id === entity.id && <span className="nav-switch-tick">✓</span>}
                                </div>
                            ))}
                            <div className="nav-switch-divider" />
                        </div>
                    )}

                    <ul>
                        {/* <li onClick={() => { ChaNgeTab('activity'); }}>Profile</li> */}
                        <li onClick={() => { ChaNgeTab('friends'); }}>
                            Friends {pendingCount > 0 && <span style={{ background: '#ff4444', color: '#fff', borderRadius: '99px', fontSize: '11px', padding: '1px 6px', fontWeight: 'bold', marginLeft: '4px' }}>{pendingCount}</span>}
                        </li>
                        <li onClick={() => { ChaNgeTab('groups'); }}>Groups</li>
                        <li><Link to="#">Adverts</Link></li>
                        <li onClick={() => { ChaNgeTab('forums'); }}>Forums</li>
                        <li onClick={() => { ChaNgeTab('notifications'); }}>Notifications</li>
                        <li onClick={() => { ChaNgeTab('messages'); }}>Messages</li>
                        <li onClick={() => { ChaNgeTab('settings'); }}>Settings</li>
                        <li><Link to="#" onClick={Logout}>Log Out</Link></li>
                    </ul>
                </div>
            )}
        </div>
        </>
    );
};

export default Navigation;
